/**
 * 营销活动
 */
import React from 'react';
import './index.less';
export enum ActivityVersionEnum {
  /** 传统主题活动 */
  TRADITION = 1,
  /** 新版本招商活动 */
  NEW_ZHAOSHANG = 2,
  /** 开放报名活动 或 频道会场活动 */
  OPEN = 3,
}

export interface PlanActivityItem {
  /** poolId */
  poolId?: string;
  /** 活动id */
  id: string;
  /** 活动名称 */
  activityName: string;
  /** 活动开始时间 */
  activityStartTime: Date;
  /** 活动结束时间 */
  activityEndTime: Date;
  /** 招商截止时间 */
  businessEndTime: Date;
  /** 活动级别 有一堆枚举 具体看https://cf.jd.com/pages/viewpage.action?pageId=635951916 */
  level: string;
  /** 活动级别名称 */
  levelName: string;
  /** 活动计划code */
  planCode: string;
  /** 活动版本 */
  activityVersion: ActivityVersionEnum;
}

const levelColorMapping = (level: string): string => {
  switch (level) {
    case '10000': // 事业群全年S级
      return '#0E2FB3';
    case '10100': // 平台大促S级
      return '#D9363C';
    case '10200': // 平台大促A+级
      return '#FF4C4C';
    case '10300': // 平台大促A级
    case '10400': // 平台大促B级
      return '#FF7A75';
    case '11800': // 事业部S级
      return '#1C48D9';
    case '11900': // 事业部A级
      return '#2D64FF';
    case '12000': // 事业部B级
      return '#2D64FF';
    case '10500': // 王牌超级品牌日
      return '#FD8C0E';
    case '10600': // MINI超级品牌日
    case '10800': // 授权MINI超级品牌日
      return '#FEB00E';
    case '10700': // 超级品类日
      return '#0B9E5E';
    case '11700': // 超级IP日
      return '#B75AF0';
    case '11400': // PLUSDAY
      return '#26336C';
    case '11500': // PLUS A计划
      return '#233999';
    case '11000': // "宠粉日"
      return '#FFB5AC';
    default:
      return '#93ABEE';
  }
};

interface ActivityCardProps extends PlanActivityItem {
  onClick: () => void;
  buttonText: string;
}

function ActivityCard(props: ActivityCardProps) {
  const {
    level,
    levelName,
    activityName,
    activityEndTime,
    activityStartTime,
    businessEndTime,
    planCode,
    onClick,
    buttonText,
  } = props;

  return (
    <div className="marketing-activity-card">
      {level && levelName && (
        <div className="tag" style={{ background: levelColorMapping(level) }}>
          {levelName || '无'}
        </div>
      )}
      <h1 className="title">{activityName || '-'}</h1>
      <div className="content">{`活动id: ${planCode}`}</div>
      <div className="content">{`活动时间: ${activityStartTime || '-'} 至 ${activityEndTime || '-'}`}</div>
      <div className="content">{`招商截止时间: ${businessEndTime || '-'}`}</div>
      <div className="button" onClick={onClick}>
        {buttonText}
      </div>
    </div>
  );
}

export default React.memo(ActivityCard);
